/** Top-level categories for pre-owned marketplace listings (offer item flow). */
export const PRE_OWNED_ITEM_CATEGORY_DATA = {
  'Computers & Electronics': ['Mobile Phones', 'Laptops', 'Desktops', 'Tablets', 'Monitors', 'Computer Accessories', 'Networking Products', 'Printers & Scanners', 'Data Storage', 'Computer Components'],
  'Toys & Video Games': [
    'Action Figures',
    'Building Toys',
    'Dolls',
    'Board Games',
    'Puzzles',
    'Educational Toys',
    'Outdoor Play',
    'Arts & Crafts',
    'PlayStation',
    'Xbox',
    'Nintendo',
    'PC Gaming',
    'Accessories',
    'Retro Gaming',
  ],
  Clothing: [],
  Accessories: [],
  Footwear: [],
  Bags: [],
  Watches: [],
  Books: [],
  'Home & Kitchen': ['Kitchen & Dining', 'Bedding', 'Bath', 'Home Decor', 'Lighting', 'Cleaning Supplies', 'Storage & Organization', 'Wall Art'],
  'Beauty & Personal Care': ['Makeup', 'Skin Care', 'Hair Care', 'Fragrance', 'Nail Care', 'Tools & Accessories', 'Oral Care'],
  'Sports & Outdoors': ['Exercise & Fitness', 'Outdoor Recreation', 'Sports Equipment', 'Cycling', 'Camping & Hiking'],
  Baby: ['Strollers', 'Car Seats', 'Feeding', 'Nursery', 'Baby Toys', 'Diapering', 'Safety'],
  'Pet Supplies': [],
  Automotive: ['Interior Accessories', 'Exterior Accessories', 'Tires & Wheels', 'Tools & Equipment', 'Car Care'],
  'Arts & Crafts': ['Painting & Drawing', 'Beading & Jewelry Making', 'Sewing', 'Knitting & Crochet', 'Scrapbooking', 'Fabric', 'Party Supplies'],
  Stationary: ['Notebooks & Journals', 'Pens & Pencils', 'Art Supplies', 'School Supplies', 'Office Supplies', 'Planners & Calendars', 'Desk Accessories'],
  'Musical Instruments': [
    'Guitars & Basses',
    'Keyboards & Pianos',
    'Drums & Percussion',
    'Wind & Brass',
    'String Instruments',
    'DJ & Recording Equipment',
    'Amplifiers & Effects',
    'Accessories & Parts',
  ],
  Luggage: ['Suitcases', 'Backpacks', 'Carry-ons', 'Travel Totes', 'Laptop Bags', 'Duffles', 'Travel Accessories'],
  'Tools & Home Improvement': ['Power Tools', 'Hand Tools & Hardware', 'Plumbing', 'Painting Supplies'],
};

export const PRE_OWNED_ITEM_CATEGORIES = Object.keys(PRE_OWNED_ITEM_CATEGORY_DATA);

/** Categories hidden from /list-luxury-piece (pre-owned listing still shows them). */
export const LUXURY_LISTING_EXCLUDED_CATEGORIES = [
  'Computers & Electronics',
  'Toys & Video Games',
  'Books',
  'Pet Supplies',
  'Automotive',
  'Tools & Home Improvement',
  'Musical Instruments',
];

export const LUXURY_ITEM_CATEGORIES = PRE_OWNED_ITEM_CATEGORIES.filter(
  (category) => !LUXURY_LISTING_EXCLUDED_CATEGORIES.includes(category)
);
